export enum OrderbookSource {
  TSE,
  OrderBook,
  OrderBookOld,
  Sahra,
  Ramand,
  VirtualOrderbook,
  TadbirIME,
  CdnIME,
  SahraIME,
  RamandSite = 9,
  SahraPush = 10,
  Mofid = 11,
  TadbirSite = 12,
}

export interface ISettingDTO {
  orderbookSource: OrderbookSource;
  imEorderbookSource: OrderbookSource;
  accountIds: string[];
  orderConfigHistoryAutoReset: boolean;
  orderConfigDayCount: number;
}
